import React, { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { Controlled as ControlledEditor } from 'react-codemirror2'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/material-darker.css'
import 'codemirror/mode/python/python'

const QueryEditor = ({ value, onChange }) => {
    const editorInstance = useRef(null)
    const themeMode = useSelector(state => state.theme?.mode || 'light')

    const editorDidMountFn = editor => {
        editorInstance.current = editor
    }

    useEffect(() => {
        const handleKeyUp = event => {
            if (event.key === 'm' && event.ctrlKey) {
                editorInstance.current.addKeyMap({ Tab: false })
            }
        }

        document.addEventListener('keyup', handleKeyUp, true)

        return () => {
            document.removeEventListener('keyup', handleKeyUp, true)
        }
    }, [])

    const handleChange = (editor, data, value) => {
        onChange(value)
    }

    const editor = (
        <ControlledEditor
            onBeforeChange={handleChange}
            value={value}
            editorDidMount={editorDidMountFn}
            options={{
                theme: themeMode === 'dark' ? 'material-darker' : 'default',
                mode: 'python',
                lineWrapping: true,
                lint: true,
                autocorrect: true,
                readOnly: false,
                autofocus: true,
                screenReaderLabel: 'query',
            }}
        />
    )

    return <div className='query_editor__container'>{editor}</div>
}

export default QueryEditor
